import React, { useState } from 'react';
   import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
   import Alert from './common/Alert';
   import { requestPasswordReset } from '../services/auth';

   const ForgotPassword = ({ onBackToLogin }) => {
     const [email, setEmail] = useState('');
     const [message, setMessage] = useState('');
     const [error, setError] = useState('');

     const handleSubmit = async (e) => {
       e.preventDefault();
       setMessage('');
       setError('');
       try {
         const response = await requestPasswordReset(email);
         setMessage(response.message);
       } catch (err) {
         setError('Errore nell\'invio della richiesta');
       }
     };

     return (
       <Container className="mt-4">
         <Row className="justify-content-center">
           <Col md={6} lg={5}>
             <Card className="shadow-sm">
               <Card.Body>
                 <Alert variant="success" message={message} />
                 <Alert variant="danger" message={error} />
                 <div className="d-flex align-items-center justify-content-center mb-4">
                   <span className="fs-4 me-2">🔑</span>
                   <h2 className="fw-bold mb-0">Recupera Password</h2>
                 </div>
                 <Form onSubmit={handleSubmit}>
                   <Form.Group className="mb-3">
                     <Form.Label>Email</Form.Label>
                     <Form.Control
                       type="email"
                       value={email}
                       onChange={(e) => setEmail(e.target.value)}
                       required
                     />
                   </Form.Group>
                   <div className="d-grid">
                     <Button variant="primary" type="submit">
                       Invia Email di Reset
                     </Button>
                   </div>
                   <div className="text-center mt-3">
                     <a href="#" className="text-decoration-none" onClick={onBackToLogin}>
                       Torna al Login
                     </a>
                   </div>
                 </Form>
               </Card.Body>
             </Card>
           </Col>
         </Row>
       </Container>
     );
   };

   export default ForgotPassword;